import AllFilePreview from "../../../../../components/ViewAllFile";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import { useGetEobById } from "../../../../../queries/billings/eob/use-get-eob-by-id";
import { DOC_TYPE_MAPPER } from "../../patient/patient-list/patient-chart-new/document/document-constant";

interface EobDocumentPreviewProps {
  disclosureHost: DisclosureHost;
}

const EobDocumentPreview = ({ disclosureHost }: EobDocumentPreviewProps) => {
  const eobUuid = disclosureHost.opened ? disclosureHost.data : undefined;

  const { data: eobDetail } = useGetEobById(eobUuid);
  const eobData = (eobDetail as any)?.data as
    | {
        document?: string;
        documentFormat?: string;
        documentName?: string;
      }
    | undefined;

  return (
    <AllFilePreview
      disclosureHost={disclosureHost}
      file={eobData?.document}
      fileType={DOC_TYPE_MAPPER[eobData?.documentFormat ?? ""] ?? "other"}
      title="Preview EOB Document"
      w="60vw"
    />
  );
};

export default EobDocumentPreview;
